import { plural } from 'utilities/plural'

import classes from './index.module.scss'

interface Props {
  amount: number
  word: string
}
export const EmptyDetail = ({ amount, word }: Props) => (
  <section className={classes.root}>
    <strong>
      {amount} {plural(word, amount)} found
    </strong>
    <p>Click on a {word} to see more details</p>
  </section>
)
